import _toConsumableArray from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import ArcGisSearcher from './searchers/ArcGisSearcher';
import CVR_enhedSearcher from './searchers/CVR_enhedSearcher';
import DataSearcher from './searchers/DataSearcher';
import SearchableData from './searchers/local/SearchableData';
import DawaSearcher from './searchers/DawaSearcher';
import DawaStednavnSearcher from './searchers/DawaStednavnSearcher';
import GeoStednavnSearcher from './searchers/GeoStednavnSearcher';
import GeoSearch from './searchers/GeoSearch';
import PlanSearcher from './searchers/PlanSearcher';
import PlanSystemSearcher from './searchers/PlanSystemSearcher';
import PostgRESTSearcher from './searchers/PostgRESTSearcher';
import S4IndexSearcher from './searchers/S4IndexSearcher';
import S3Searcher from './searchers/S3Searcher';
import SqSearcher from './searchers/SqSearcher';
import IsoChroneSearcher from './searchers/IsoChroneSearcher';
import ClientSearcher from './searchers/ClientSearcher';
import jsonpath from '@septima/jsonpath';
import SqDetailsHandler from "./details/SqDetailsHandler";
import SearchableGeoJson from "./searchers/local/SearchableGeoJson";
import TinglysningerForAdresseHandler from "./searchers/detailhandlers/TinglysningerForAdresseHandler";
import DokLinksForLokalplan from "./searchers/detailhandlers/DokLinksForLokalplan";
import BbrLinkHandler from "./searchers/detailhandlers/BbrLinkHandler";
import SvurLinkHandler from "./searchers/detailhandlers/SvurLinkHandler";
import ComposedDetailHandler from "./details/ComposedDetailHandler";
import JordForureningsattestLinkHandler from "./searchers/detailhandlers/JordForureningsattestLinkHandler";
import CvrLinkHandler from "./searchers/detailhandlers/CvrLinkHandler";
import DagiInfoForPunktHandler from "./searchers/detailhandlers/DagiInfoForPunktHandler";
import MatrikelInfoHandler from "./searchers/detailhandlers/MatrikelInfoHandler";
import S4InfoHandler from "./searchers/detailhandlers/S4InfoHandler";
import Controller from './Controller';

var ClassRegistry =
/*#__PURE__*/
function () {
  function ClassRegistry(parent) {
    _classCallCheck(this, ClassRegistry);

    this.parent = parent;
    this.registry = {};
  }

  _createClass(ClassRegistry, [{
    key: "spawn",
    value: function spawn() {
      return new ClassRegistry(this);
    }
  }, {
    key: "addClass",
    value: function addClass(class2Add, className) {
      if (typeof this.parent === 'undefined') throw new Error('ClassRegistry.addClass is not allowed on root classRegistry. Use .spawn() to create child registry');

      this._takeClass(class2Add, className);
    }
  }, {
    key: "_takeClass",
    value: function _takeClass(class2Add, className) {
      if (typeof className !== 'undefined') this.registry[className] = class2Add;else throw new Error('ClassRegistry.takeClass called without className');
    }
  }, {
    key: "forClass",
    value: function forClass(className, options) {
      if (typeof this.registry[className] === 'undefined') {
        if (typeof this.parent !== 'undefined') return this.parent.forClass(className, options);else throw new Error('Class not found. Class ' + className + ' is not defined');
      } else return new this.registry[className](options);
    }
  }, {
    key: "find",
    value: function find(obj, elementChriteria) {
      var nodes1 = jsonpath.nodes(obj, elementChriteria);
      var nodes2 = jsonpath.nodes({
        obj: obj
      }, "$.." + elementChriteria); //nodes2.splice(1,1)

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = nodes2[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var node = _step.value;
          node.path.splice(1, 1);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return [].concat(_toConsumableArray(nodes1), _toConsumableArray(nodes2));
    }
  }, {
    key: "parse",
    value: function parse(object) {
      var typeNodes = []; // of jsonpath.node

      var refNodes = []; // of jsonpath.node

      var subTypes = []; // {parent: jsonpath.node, child: jsonpath.node, childPath}

      var subRefs = []; // {parent: jsonpath.node, child: jsonpath.node}

      var reffedTypes = []; // {referringNode: jsonpath.node, refersToPath: path}
      //Object may contain "_type", and "_ref" tags

      var cleanObject = JSON.parse(JSON.stringify(object)); //typeNodes = jsonpath.nodes(cleanObject, '$..*[?(@._type)]')

      typeNodes = this.find(cleanObject, '*[?(@._type)]'); //refNodes = jsonpath.nodes(cleanObject, '$..*[?(@._ref)]')

      refNodes = this.find(cleanObject, '*[?(@._ref)]');
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = refNodes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var refNode = _step2.value;
          var refersTo = jsonpath.value(cleanObject, refNode.value['_ref']);
          if (typeof refersTo === 'undefined' || refersTo === null) throw new Error("refnode at " + jsonpath.stringify(refNode.path) + " with value " + refNode.value['_ref'] + " doesn't point to anything");else if (typeof refersTo._type === 'undefined') jsonpath.value(cleanObject, jsonpath.stringify(refNode.path), refersTo);else reffedTypes.push({
            referringNode: refNode,
            refersToPath: refNode.value['_ref']
          });
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = typeNodes[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var typeNode = _step3.value;
          //let subRefNodes = jsonpath.nodes(typeNode.value, '$..*[?(@._ref)]')
          var subRefNodes = this.find(typeNode.value, '*[?(@._ref)]');
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = subRefNodes[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var subRefNode = _step4.value;
              subRefs.push({
                parent: typeNode,
                child: subRefNode
              });
            } //let subTypeNodes = jsonpath.nodes(typeNode.value, '$..*[?(@._type)]')

          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }

          var subTypeNodes = this.find(typeNode.value, '*[?(@._type)]');
          var _iteratorNormalCompletion5 = true;
          var _didIteratorError5 = false;
          var _iteratorError5 = undefined;

          try {
            for (var _iterator5 = subTypeNodes[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              var subTypeNode = _step5.value;
              var childPath = [].concat(_toConsumableArray(typeNode.path), _toConsumableArray(subTypeNode.path.slice(1)));
              subTypes.push({
                parent: typeNode,
                child: subTypeNode,
                childPath: childPath
              });
            }
          } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                _iterator5.return();
              }
            } finally {
              if (_didIteratorError5) {
                throw _iteratorError5;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return {
        object2Return: cleanObject,
        typeNodes: typeNodes,
        refNodes: refNodes,
        subTypes: subTypes,
        subRefs: subRefs,
        reffedTypes: reffedTypes
      };
    }
  }, {
    key: "resolve",
    value: function resolve(object) {
      var _this = this;

      //Hack since jsonpath cant find first level children
      var parseResult = this.parse(object);
      var typenodeInstances = [];

      while (parseResult.typeNodes.length > 0) {
        var typeNodeCount = parseResult.typeNodes.length;

        for (var i = parseResult.typeNodes.length - 1; i >= 0; i--) {
          var typeNode = parseResult.typeNodes[i];
          var optionsChildren = this.optionChildren(typeNode, parseResult);

          if (optionsChildren.length === 0) {
            var instance = this.instantiate(typeNode, parseResult); //Remove from typeNodes

            parseResult.typeNodes.splice(i, 1);
            var children = this.children(typeNode, parseResult);
            if (children.length === 0) this.insertType(typeNode, instance, parseResult);else //Insert into collection for later insert
              typenodeInstances.push({
                typeNode: typeNode,
                instance: instance
              });
          }
        }

        if (parseResult.typeNodes.length === typeNodeCount) {
          // No nodes have been resolved in this pass -> Throw Error
          var unresolvablePaths = parseResult.typeNodes.map(function (typeNode) {
            return {
              "path": jsonpath.stringify(typeNode.path),
              "children": _this.children(typeNode, parseResult)
            };
          });
          throw new Error("Can't resolve: Unresolvable nodes: " + JSON.stringify(unresolvablePaths, null, 2));
        }
      } //TBD Eliminate refs to non-types


      while (typenodeInstances.length > 0) {
        var typenodeInstanceCount = typenodeInstances.length;

        for (var _i = typenodeInstances.length - 1; _i >= 0; _i--) {
          var _typenodeInstances$_i = typenodeInstances[_i],
              _typeNode = _typenodeInstances$_i.typeNode,
              _instance = _typenodeInstances$_i.instance;

          var _children = this.children(_typeNode, parseResult);

          if (_children.length === 0) {
            this.insertType(_typeNode, _instance, parseResult);
            typenodeInstances.splice(_i, 1);
          }
        }

        if (typenodeInstances.length === typenodeInstanceCount) {
          // No nodes have been resolved in this pass -> Throw Error
          var _unresolvablePaths = typenodeInstances.map(function (typenodeInstance) {
            return {
              "path": jsonpath.stringify(typenodeInstance.typeNode.path),
              "children": _this.children(typenodeInstance.typeNode, parseResult)
            };
          });

          throw new Error("Can't insert: Uninsertable nodes: " + JSON.stringify(_unresolvablePaths, null, 2));
        }
      } //We got to here - this means all typenodes have been converted to typenodeInstances 


      return parseResult.object2Return;
    }
  }, {
    key: "children",
    value: function children(typeNode, parseResult) {
      var children = [];
      var pathToCheck = jsonpath.stringify(typeNode.path);
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = parseResult.subTypes[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var subType = _step6.value;
          if (jsonpath.stringify(subType.parent.path) === pathToCheck) children.push(subType.child.path);
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = parseResult.subRefs[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var subRef = _step7.value;
          if (jsonpath.stringify(subRef.parent.path) === pathToCheck) children.push(subRef.child.path);
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      return children;
    }
  }, {
    key: "optionChildren",
    value: function optionChildren(typeNode, parseResult) {
      var children = [];
      var pathToCheck = jsonpath.stringify(typeNode.path);
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = parseResult.subTypes[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var subType = _step8.value;
          if (jsonpath.stringify(subType.parent.path) === pathToCheck && subType.child.path[1] === '_options') children.push(subType.child.path);
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = parseResult.subRefs[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var subRef = _step9.value;
          if (jsonpath.stringify(subRef.parent.path) === pathToCheck && subRef.child.path[1] === '_options') children.push(subRef.child.path);
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      return children;
    }
  }, {
    key: "insertType",
    value: function insertType(typeNode, instance, parseResult) {
      this.setInstanceProperties(instance, typeNode.value); // set the type member to the instance

      var typeNodePath = jsonpath.stringify(typeNode.path);
      jsonpath.value(parseResult.object2Return, typeNodePath, instance); // Remove the subType info

      parseResult.subTypes = parseResult.subTypes.filter(function (subType) {
        return jsonpath.stringify(subType.childPath) !== typeNodePath;
      });
    }
  }, {
    key: "instantiate",
    value: function instantiate(typeNode, parseResult) {
      var typeNodePath = jsonpath.stringify(typeNode.path); //Create an instance

      var instance = this.forClass(typeNode.value['_type'], typeNode.value._options);

      for (var i = parseResult.reffedTypes.length - 1; i >= 0; i--) {
        var reffedType = parseResult.reffedTypes[i]; //{referringNode: jsonpath.node, refersToPath: path}

        if (reffedType.refersToPath === typeNodePath) {
          //The reffedType is the typeNode
          var referringPath = jsonpath.stringify(reffedType.referringNode.path); // set the _ref member to the instance

          jsonpath.value(parseResult.object2Return, referringPath, instance); // Remove the reffed info

          parseResult.reffedTypes.splice(i, 1); //parseResult.subRefs = parseResult.subRefs.filter(subRef => jsonpath.stringify(subRef.child.path) !== referringPath)

          parseResult.subRefs = parseResult.subRefs.filter(function (subRef) {
            return jsonpath.stringify(subRef.child.value["_ref"]) !== typeNodePath;
          });
        }
      }

      return instance;
    }
  }, {
    key: "setInstanceProperties",
    value: function setInstanceProperties(instance, typeNodeValue) {
      Object.keys(typeNodeValue).forEach(function (propertyName) {
        if (propertyName !== '_type' && propertyName !== '_options') instance[propertyName] = typeNodeValue[propertyName];
      });
    }
  }]);

  return ClassRegistry;
}();

var proxy = {
  instance: null,
  _getInstance: function _getInstance() {
    if (proxy.instance === null) {
      var instance = new ClassRegistry();
      var builtInClasses = [ArcGisSearcher, CVR_enhedSearcher, DataSearcher, ClientSearcher, DawaSearcher, DawaStednavnSearcher, GeoStednavnSearcher, GeoSearch, PlanSearcher, PlanSystemSearcher, PostgRESTSearcher, S4IndexSearcher, S3Searcher, SqSearcher, IsoChroneSearcher, SearchableData, SearchableGeoJson, SqDetailsHandler, TinglysningerForAdresseHandler, DokLinksForLokalplan, BbrLinkHandler, SvurLinkHandler, ComposedDetailHandler, JordForureningsattestLinkHandler, CvrLinkHandler, DagiInfoForPunktHandler, MatrikelInfoHandler, S4InfoHandler, Controller];
      builtInClasses.forEach(function (builtInClass) {
        instance._takeClass(builtInClass, builtInClass.prototype.CLASS_NAME);
      });
      proxy.instance = instance.spawn();
    }

    return proxy.instance;
  },
  parse: function parse(object) {
    return proxy._getInstance().parse(object);
  },
  spawn: function spawn() {
    return proxy._getInstance().spawn();
  },
  addClass: function addClass(addedClass, className) {
    proxy._getInstance().addClass(addedClass, className);
  },
  resolve: function resolve(object) {
    return proxy._getInstance().resolve(object);
  },
  forClass: function forClass(className, options) {
    return proxy._getInstance().forClass(className, options);
  }
};
export default proxy;